import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import PreviewModal from './PreviewModal';
import Filter from './Filter';
import '../style/home.less';
import moment from 'moment';
import { saveSearchParams } from '../../../actions/rankActions';

const monthFormat = 'YYYY-MM';

class TeamRecommendTalentRank extends Component {
    constructor(props) {
        super(props);
        const { match: { params: { date } }, performanceState = {} } = this.props;
        const { params, pagination } = performanceState;
        const defaultMonth = moment(date).format(monthFormat);
        this.state = {
            searchParams: {
                defaultMonth,
                inspectionTime: defaultMonth,
                ...params,
            },
            pagination: {
                pageSize: 10,
                current: 1,
                ...pagination,
            },
            loading: false,
            list: [],
        }
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { year, month } = res;
            const maxDate = `${year}-${month < 10 ? `0${month}` : month}`;
            this.setState({ maxDate }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { pagination: { current, pageSize }, searchParams } = this.state;
        const { areaParams = {} } = searchParams;

        this.setState({ loading: true });
        const queryData = {
            offset: current,
            limit: pageSize,
            ...searchParams,
            ...areaParams,
        };
        delete queryData.areaParams;
        delete queryData.hasCheckedArea;
        const options = {
            method: 'POST',
            url: API_URL.home.queryUserInternalRecommendIdList,
            data: queryData,
            dataType: 'json',
            doneResult: res => {
                const { pagination } = this.state;
                const { datas, totalCount } = res.result;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    list: datas,
                    loading: false,
                    meanValue: res.avg,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '排名',
            dataIndex: 'rank',
            width: 85,
        }, {
            title: '团队领导姓名',
            dataIndex: 'userCompellation',
            width: 175,
        }, {
            title: '团队领导工号',
            dataIndex: 'employeeCode',
            width: 175,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            width: 185,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            width: 170,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            width: 170,
        }, {
            title: '团队推荐转正人数',
            dataIndex: 'peopleCount',
            width: 170,
            render: (text, record) => {
                return <a onClick={() => this.showPreviewModal(record)}>{text}</a>
            }
        }
    ])

    getDataSource = () => {
        const { list } = this.state;
        const dataSource = list.map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    showPreviewModal = (record) => {
        this.preivewModalRef.show(record);
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ searchParams: {...params} }, () => {
            this.loadData();
        })
    }

    export = () => {
        const { pagination, sortParams, searchParams } = this.state;
        ExportUtil.export({ ...sortParams, ...searchParams }, pagination, API_URL.home.exportUserInternalRecommendIdList);
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { maxDate = '', loading, pagination, searchParams } = this.state;
        return (
            <div className="container">
                <div className="full whole-page">
                    <div className="header">
                        团队推荐转正人才排名
                        <span className="return-back" onClick={() =>  this.props.history.push({pathname: `/home`, state: {key: 'performanceRank'}})}>
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px' }}
                            >&#xe63d;</i>
                            返回
                        </span>
                    </div>
                    <Filter
                        maxDate={maxDate}
                        search={this.search}
                        export={this.export}
                        searchParams={searchParams}
                    />
                    <Table
                        bordered
                        loading={loading}
                        scroll={{x: 1130}}
                        pagination={pagination}
                        columns={this.getColumns()}
                        onChange={this.handleTableChange}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.index}
                    />
                    <PreviewModal ref={el => this.preivewModalRef = el} searchParams={searchParams} />
                </div>
            </div>
        )
    }
}

const mapSateToProps = (state) => ({
    performanceState: state.rankState.params || {},
});

const mapDispatchToProps = (dispatch) => ({
    saveParams: (params) => dispatch(saveSearchParams(params))
})

export default connect(mapSateToProps, mapDispatchToProps)(TeamRecommendTalentRank);


// WEBPACK FOOTER //
// ./src/components/home/teamRecommendTalentRank/index.js